<div class="container">
    <div class="img-logo">
        <img src="./../../assets/logo.png" class="logo">
    </div>
    <p class="bold">ברוכות וברוכים הבאים לקורפוס עממ"י</p>
    <p>
        קורפוס עממ"י הוא הקורפוס הטקסטואלי העברי הראשון של ראשית המאה העשרים שהינו חופשי להורדה, למחקר ולהעשרה. הקורפוס
        מאגד טקסטים ממקורות שונים ומסוּגות שונות. הוא כולל יצירות ספרות, מודעות וכרזות, מכתבים, יומנים אישיים ועוד. חלקו
        של הקורפוס, שמבוסס על
        <a href="https://benyehuda.org/">"פרויקט בן-יהודה"</a>
        , מייצג את השפה העברית הספרותית שנכתבה בעט סופר. חלקיו האחרים מייצגים שפת
        יום-יום לא רשמית שכתבו בה אנשים ונשים מהיישוב. שפה זו נחשפת במסמכים "בני חלוף" (חוֹלְפוֹת, ephemera), כמו אלה
        השמורים בספרייה הלאומית בפרויקט
        <a href="https://www.nli.org.il/he/at-your-service/who-we-are/projects/time-travel">"מסע בזמן"</a>
        ובארכיונים שונים. הקורפוס מכיל אך ורק חומרים שבנחלת הכלל או חומרים
        שהתקבל אישור מפורש להנגישם לחיפוש.

    </p>
    <p>קורפוס עממ"י נבנה במטרה לתמוך במחקר לשוני היסטורי של העברית החדשה. בעזרת המסמכים נחשפים שלבי התפתחותה של העברית
        בשנים שבהן הפכה שוב לשפה חיה, סביב ראשית המאה העשרים. במהלך בניית הקורפוס המסמכים נסרקים, תוכנם נחשף (אם בהקלדה
        ואם באמצעות תוכנה ייעודית לזיהוי כתב עברי) והם מעובים במידע לשוני הכולל חלקי דיבר וניתוחים תחביריים. הניתוח
        הלשוני בגרסה הנוכחית של הקורפוס מתבצע באופן אוטומטי באמצעות תוכנת
        <a href="https://nlp.biu.ac.il/~rtsarfaty/onlp/hebrew/about">YAP</a>.
    </p>
    <p>לכל מסמך מתווסף מטא-דאטה בסיסי, הכולל את התאריך והמקום שבהם הוא נכתב. הקורפוס מונגש לחיפוש באמצעות תוכנת
        <a href="https://corpus-tools.org/annis/">ANNIS</a>,
        שמאפשרת חיפושים המצליבים את כל פריטי המידע הללו.
    </p>
    <p>הנגשתו של קורפוס עממ"י על שרת זה מאפשרת כעת לכל אחת ולכל אחד לערוך חיפושים במאגר, לשמור את תוצאות החיפושים ולשתף
        תוצאות אלה עם אחרים על פי העיקרון המדעי הבסיסי של הדירוּת (reproducible science).</p>
    <p>שאלות, הערות או תובנות? אנא צרו איתנו
        <a href="mailto:aynat.rubinstein@mail.huji.ac.il">קשר</a>.
    </p>
    <p>בהנאה!</p>
    <div class="corpusButton">
            <button mat-raised-button class="button">
        <a href="http://jemh.researchsoftwarehosting.org/annis/">
            GO TO CORPUS
        </a>
    </button>
    </div>
<p></p>
    <p class="bold">תנאי השימוש</p>
    <p>
        הקורפוס שימש אותך במחקר? יש לציין זאת בפרסומים, כך:
    </p>
    <p dir="ltr"> Rubinstein, Aynat. 2019.
        <a href="https://link.springer.com/article/10.1007/s10579-019-09458-4">Historical Corpora Meet the Digital Humanities: The Jerusalem Corpus of Emergent Modern Hebrew.</a>
        Language Resources and Evaluation 53(4): 807-835.
    </p>
    <p class="bold">כלי עזר</p>
    <p dir="ltr">
        <span>More, Amir, Amit Seker, Victoria Basmova, and Reut Tsarfaty. 2019.
            <a href="https://direct.mit.edu/tacl/article/doi/10.1162/tacl_a_00253/43498/Joint-Transition-Based-Models-for-Morpho-Syntactic">Joint Transition-Based Models for Morpho-Syntactic Parsing: Parsing Strategies for MRLs and a
                Case Study from Modern Hebrew.</a>
            Transactions of the Association for Computational Linguistics 7: 33-48. </span>
    </p>
    <p dir="ltr">Krause, Thomas and Amir Zeldes. 2016.
        <a href="https://academic.oup.com/dsh/article-abstract/31/1/118/2605493?redirectedFrom=fulltext"> ANNIS3: A New Architecture for Generic Corpus Query and Visualization. </a>
        Digital Scholarship in the Humanities 31(1): 118-139.
    </p>
</div>